export const GET_DATA_MSL_MANAGE_CLONE = 'GET_DATA_MSL_MANAGE_CLONE'
export const GET_DATA_MSL_MANAGE = 'GET_DATA_MSL_MANAGE'
export const LOADING_DATA_MSL_MANAGE = 'LOADING_DATA_MSL_MANAGE'
export const GET_DATA_MSL_MANAGE_CURRENT_SOURCE = 'GET_DATA_MSL_MANAGE_CURRENT_SOURCE'
export const GET_DATA_CHANNELS_MSL_MANAGE = 'GET_DATA_CHANNELS_MSL_MANAGE'
export const SHOW_MODAL_NOTIFICATIONS_ALERT = 'SHOW_MODAL_NOTIFICATIONS_ALERT'
export const DATA_MODAL_NOTIFICATIONS_ALERT = 'DATA_MODAL_NOTIFICATIONS_ALERT'